import {StyleSheet, View} from 'react-native';
import QuickBtn from './quick-btn';
import Price from '@/components/business/price';
import Text from '@/components/basic/text';
import theme from '@/style';
import LinearGradient from '@/components/basic/linear-gradient/linear-gradient';
import React from 'react';
import {BasicObject} from '@/types';
import {useTranslation} from 'react-i18next';

const LEVEL_MAP = {
  1: 'single',
  2: 'double',
  3: 'triple',
} as BasicObject;

export interface BetsHeaderProps {
  winPrize?: number;
  level?: number;
  payment?: number;
  onGuess?: () => void;
}

const BetsHeader = (props: BetsHeaderProps) => {
  const {winPrize = 0, payment = 1, level = 1, onGuess} = props;

  const title = React.useMemo(() => {
    if (level) {
      return LEVEL_MAP[level];
    }
    return '';
  }, [level]);

  const {i18n} = useTranslation();

  return (
    <View style={styles.wrap}>
      <View style={styles.leftWrap}>
        <View style={styles.titleRow}>
          <View style={styles.titleWrap}>
            <Text
              fontSize={16}
              fontFamily="fontInterBold"
              color={theme.fontColor.main}>
              {title ? i18n.t(`game-page.label.${title}`) : ''}
            </Text>
            <Text fontSize={16} fontFamily="fontInterBold" accent>
              {' '}
              {i18n.t('game-page.label.digit')}
            </Text>
          </View>
          <LinearGradient
            colors={['#C971FF', '#FF996000']}
            start={{
              x: 0,
              y: 0,
            }}
            end={{
              x: 1,
              y: 0,
            }}
            style={styles.winTag}>
            <Text
              style={styles.winText}
              fontSize={10}
              fontFamily="fontInterBold">
              {i18n.t('game-page.label.win')}
            </Text>
            <Price
              textProps={{
                fontSize: 14,
                color: theme.fontColor.main,
              }}
              price={winPrize}
            />
          </LinearGradient>
        </View>
        <Price
          price={payment}
          textProps={{
            fontSize: 14,
            color: theme.fontColor.main,
            fontFamily: 'fontInterBold',
          }}
        />
      </View>
      <QuickBtn onPress={onGuess} />
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  leftWrap: {
    flex: 1,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 4,
  },
  winTag: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
    height: 20,
    borderBottomLeftRadius: 8,
  },
  winText: {
    marginRight: 4,
  },
});

export default BetsHeader;
